
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SingularityPanelHeader from "../PanelHeader/SingularityPanelHeader.vue";
import BrandManageColors from "./Color/BrandManageColors.vue";
import { saveBrandSettings } from "@/lib/singularity/brand/settings";
import BrandManageTypography from "./Typography/BrandManageTypography.vue";
import BrandManageButtons from "./Buttons/BrandManageButtons.vue";
import BrandManageLogo from "./Logo/BrandManageLogo.vue";

@Component({
  components: {
    SingularityPanelHeader,
    BrandManageLogo,
    BrandManageColors,
    BrandManageTypography,
    BrandManageButtons
  }
})
export default class BrandPanel extends Vue {
  loadingSettings = false;

  async saveBrandSettings() {
    this.loadingSettings = true;
    await saveBrandSettings();
    this.loadingSettings = false;
  }

  destroyed() {
    document.removeEventListener(
      "breakdanceSaveButtonClicked",
      this.saveBrandSettings
    );
  }

  mounted() {
    document.addEventListener(
      "breakdanceSaveButtonClicked",
      this.saveBrandSettings
    );
  }
}
